import { createSlice } from '@reduxjs/toolkit'
let initialState;


const menuToggleDefaultValue  = JSON.parse(localStorage.getItem("redux_menu")) ||{toggle:'',minimize:'on'}
const menuToggleSlice = createSlice({
    name: 'menuToggle',
    initialState: menuToggleDefaultValue,
    reducers: {
        menuToggle: (state) => {
            if(state.toggle =='' ){
                state.toggle ='active';
                state.minimize ='off';
            }else{
                state.toggle ='';
                state.minimize ='on';
            }
            localStorage.setItem("redux_menu",  JSON.stringify(state));

        }
    },
});

const activeDefaultValue  = JSON.parse(localStorage.getItem("redux_menu_active")) ? {active:JSON.parse(localStorage.getItem("redux_menu_active"))} :{active:{}}

const  menuActiveSlice = createSlice({
    name: 'active',
    initialState:  activeDefaultValue,
    reducers: {
        activated: (state,newVal) => {
            state.active = newVal.payload;
            localStorage.setItem("redux_menu_active",  JSON.stringify(state.active));

        }
    },
});



const clientLogoSlice = createSlice({
    name: 'clientLogo',
    initialState: { url: localStorage.getItem('ClientLogo') || '' },
    reducers: {
        setClientLogo: (state, action) => {
            state.url = action.payload;
        }
    },
});

const siteClientLogoSlice = createSlice({
    name: 'siteClientLogo',
    initialState: { url: localStorage.getItem('SiteClientLogo') || '' },
    reducers: {
        setSiteClientLogo: (state, action) => {
            state.url = action.payload;
        }
    },
});


const userProfileDefaultValue = (() => {
    try {
        return JSON.parse(localStorage.getItem("userProfile")) || null;
    } catch {
        return null;
    }
})();

const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState: { data: userProfileDefaultValue },
    reducers: {
        setUserProfile: (state, action) => {
            state.data = action.payload;
            if (action.payload) {
                localStorage.setItem("userProfile", JSON.stringify(action.payload));
            } else {
                localStorage.removeItem("userProfile");
            }
        },
        updateUserProfile: (state, action) => {
            state.data = { ...(state.data || {}), ...action.payload };
            localStorage.setItem("userProfile", JSON.stringify(state.data));
        }
    },
});

const notificationDefaultCount = (() => {
    try {
        const raw = localStorage.getItem("notification_count");
        const parsed = parseInt(raw, 10);
        return isNaN(parsed) ? 0 : parsed;
    } catch {
        return 0;
    }
})();

const notificationSlice = createSlice({
    name: 'notification',
    initialState: { count: notificationDefaultCount },
    reducers: {
        setNotificationCount: (state, action) => {
            const count = typeof action.payload === 'number' ? action.payload : parseInt(action.payload, 10) || 0;
            state.count = count >= 0 ? count : 0;
            localStorage.setItem("notification_count", state.count.toString());
        },
        clearNotificationCount: (state) => {
            state.count = 0;
            localStorage.setItem("notification_count", "0");
        }
    },
});

const  menuToggles = menuToggleSlice.reducer ;
const  menuActive = menuActiveSlice.reducer ;
const  clientLogoReducer = clientLogoSlice.reducer;
const  siteClientLogoReducer = siteClientLogoSlice.reducer;
const  userProfileReducer = userProfileSlice.reducer;
const  notificationReducer = notificationSlice.reducer;

export const { menuToggle } = menuToggleSlice.actions
export const { activated } = menuActiveSlice.actions
export const { setClientLogo } = clientLogoSlice.actions
export const { setSiteClientLogo } = siteClientLogoSlice.actions
export const { setUserProfile, updateUserProfile } = userProfileSlice.actions
export const { setNotificationCount, clearNotificationCount } = notificationSlice.actions

export {menuToggles, menuActive, clientLogoReducer, siteClientLogoReducer, userProfileReducer, notificationReducer};

